import { render } from "./WCHamburgerMenu.vue?vue&type=template&id=3da2dbc9"
import script from "./WCHamburgerMenu.vue?vue&type=script&lang=js"
export * from "./WCHamburgerMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__